// §10.5 — the information cell's sticky offset, which is the one thing about it CSS cannot ask.
//
// The rule is `top: min(--temi-sticky-offset, window − cell)`:
//
//   • a cell that FITS under the header pins there, exactly as it always has;
//   • a cell TALLER than the window gets a NEGATIVE top equal to its overflow, so it rides up with
//     the page until its foot is on the window's bottom edge, and pins there while the gallery
//     keeps scrolling. Without it the cell pins immediately and hides its own foot for the whole
//     of the gallery — measured at 222px (1440) and 441px (1920) on Signal Orange, 900px window.
//
// Both terms are runtime measurements, not design values: the window's height, and the cell's own.
// Every value that was chosen lives in temi-pdp.css and the spec; this file only does the sum.
//
// The panels open and close, so the height is not fixed at load: ResizeObserver, not one pass.
document.querySelectorAll('.temi-pdp-info').forEach((cell) => {
  const desktop = window.matchMedia('(min-width: 768px)');

  function update() {
    if (!desktop.matches) {
      // Below 768 the cell is static (§10.5) and the property would be meaningless.
      cell.style.removeProperty('--temi-pdp-sticky-top');
      return;
    }
    // Read the offset from the CASCADE rather than repeating 58 — §10.4 ruling 2 owns that number.
    // ⚠️ NOT `getPropertyValue('--temi-sticky-offset')`: a custom property hands back its SPECIFIED
    // text, and this token is `calc(var(--temi-header-height) + 2 * var(--temi-rule-width))`, so
    // parseFloat returned NaN and the short-cell case pinned at 0 instead of 58 (measured, one
    // build). Clearing our own override first makes computed `top` resolve to the token, in px.
    cell.style.removeProperty('--temi-pdp-sticky-top');
    const offset = parseFloat(getComputedStyle(cell).top) || 0;
    const top = Math.min(offset, window.innerHeight - cell.offsetHeight);
    cell.style.setProperty('--temi-pdp-sticky-top', `${Math.round(top)}px`);
  }

  update();
  // The observer sees the panels open; `box-size` reports the cell's own box, not its children's.
  new ResizeObserver(update).observe(cell);
  window.addEventListener('resize', update);
  desktop.addEventListener('change', update);
});
